import React, { Component, Fragment } from 'react';
import { db } from '../firebase/index';

import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { Redirect } from 'react-router-dom';
import styled, { keyframes } from 'styled-components';
// import { bounce, pulse, headShake, bounceIn } from 'react-animations';
import { bounceIn } from 'react-animations';
import ContentDetail from './ContentDetail';
import ContentStart from './ContentStart';

import './Content.css';


library.add(faTimes);
// const SELECTIONS = ['1', '2', '3', '4', '5', '6', '7', '8'];
let SELECTIONS = [];
const ROUND = 8;
let countdown = '';

// const bounceAnimation = keyframes`${bounce}`;
// const pulseAnimation = keyframes`${pulse}`;
// const headShakeAnimation = keyframes`${headShake}`;
const bounceInAnimation = keyframes`${bounceIn}`;

const BounceInDiv = styled.div`
  animation: 1s ${bounceInAnimation};
`;

class Content extends Component {
  state = {
    loaded: false,
    boothId: null,
    elems: SELECTIONS,
    pickedIds: [],
    round: SELECTIONS.length,
    displayResult: false,
    currentRow: 0,
  }

  componentDidMount (){
    let imgSEL = [];
    let imgThumbSEL = [];
    db.collection("images").get().then((querySnapshot) => {
      querySnapshot.forEach((doc) => {
        const url = doc.data().url;
        const name = doc.data().name;
        const urlThumb = doc.data().urlThumb;
        SELECTIONS.push({
          name: name, 
          url: url,
          urlThumb: urlThumb
        });
        imgSEL.push(url); 
        imgThumbSEL.push(urlThumb);
      })
    }).then(() => {
      var shuffle = require('shuffle-array')
      shuffle(SELECTIONS);
      const newSelections = SELECTIONS.slice(0,ROUND);
      this.setState({
        loaded: true,
        boothId: this.props.location.pathname.slice(1,),
        elems: newSelections,
        round: ROUND});
    }).then(() => {
      preloading(imgSEL);
      preloading(imgThumbSEL);
    });
    
    function preloading(imageArray) { 
         
      let n = imageArray.length; 
      for (let i = 0; i < n; i++){ 
       let img = new Image(); img.src = imageArray[i]; 
      } 
     }
  }
  
  componentDidUpdate(prevProps, prevState, snapshot) {
    // 데이터 받아온 후 update 단계 예외처리
    if (this.state.loaded) {

      const { pickedIds, round } = this.state;

      // pickedIds 업데이트
      if (round / 2 === pickedIds.length) {
          this.setState({
            elems: this.state.pickedIds,
            pickedIds: [],
            round: this.state.round / 2,
          });
      }

      // 결과로 넘어가기
      if (this.state.round === 2 && pickedIds.length === 1) {
        this.setState({
          displayResult: true,
        });
      } 
      else {
        const { displayCurrentRow } = this;
        displayCurrentRow();
        console.log(this.state.pickedIds);
        if (round === 2){
          this.startCountDown('#EB3D3A', '#EA5D93');
        }
        else if (round===ROUND && pickedIds.length === 0){}   // 시작 누르기 전에는 countDown 안하도록
        else {
          this.startCountDown('#4442FA', '#60B4FA');
        }
      }
    }

    // console.log('===============> componenet update');
  }

  displayCurrentRow = () => {
    // width 원상복귀 시키고, currentRow로 전환해주기
    const contentDetails = document.getElementsByClassName('content-detail');
    for (let i = 0; i < contentDetails.length; i += 1) {
      contentDetails[i].style.width = '49%';

      const btnWrapper = contentDetails[i].children[2]
      btnWrapper.style.visibility= 'visible';
    }

    const { currentRow } = this.state;
    try {
      const RowDivs = document.getElementsByClassName('set');
      const currentRowDiv = document.getElementsByClassName(`set${String(currentRow)}`)[0];
      for (let i = 0; i < RowDivs.length; i += 1) {
        RowDivs[i].style.display = 'none';
      }
      currentRowDiv.style.display = 'flex';
    } catch (err) {
      // console.log('error displayCurrentRow');
      // console.log(err);
    }

    // console.log('===============> display current row');
  }

  getIndex = (key, value, array) => {
    for (let i = 0; i < ROUND; i ++) {
      const dict = array[i];
      if (dict[key] === value) {
        return i;
      }
    }
    return 0;
  }

  handlePick = (e) => {
    // pickedIds에 넘기기
    const pickedName = e.target.className.split(' ')[0];
    const pickedIndex = this.getIndex('name', pickedName, this.state.elems);
    setTimeout(() => {

      // currentRow 조정하기
      const { currentRow, elems, pickedIds } = this.state;
      const nextRow = currentRow + 1 < this.state.round / 2 ? currentRow + 1 : 0;

      this.setState({
        pickedIds: pickedIds.slice().concat(elems[pickedIndex]),
        currentRow: nextRow,
      });
    }, 2000)
    
    // 선택된 elem 크기 키우기
    const pickedTarget = e.target.parentNode;
    const set = e.target.parentNode.parentNode.children;
    for(var i=0;i<2; i++){
      if(set[i]!==pickedTarget){
        set[i].style.width='0';

        const btnWrapper = set[i].children[2];
        btnWrapper.style.visibility='hidden';
      }
      else {
        pickedTarget.style.width = '70%';
      }
    }
    
    

    // console.log('===============> handle Pick');
  }
  startGame = () => {
    const contentStart = document.getElementsByClassName('content-start')[0];
    contentStart.style.display = "none";
    this.startCountDown('#4442FA', '#60B4FA');
  }
  clickImg = (e) => {
    const img = e.target.parentNode.children[0];
    const img2 = e.target.parentNode.parentNode.children[0];
    if (img.tagName === 'IMG') {
      img.click();
    }
    else {
      img2.click();
    }
    // TODO: 개선할 필요 있음. (target return two tags)
    
  }

  
  startCountDown = (frontColor, backColor) => {
    let t = 100;
    clearInterval(countdown);
    const contentMain = document.getElementsByClassName('content-main')[0];
    countdown = setInterval(() => {
        contentMain.style.backgroundImage = `linear-gradient(to right, ${frontColor} 100%, ${backColor} 0)`;
        // contentMain.style.backgroundImage = "linear-gradient(to right, #4442FA 100%, #6c9ad4 0)";
        if(t < 0){
          contentMain.style.backgroundImage = `linear-gradient(to right, ${frontColor} 100%, ${backColor} 0)`;
          clearInterval(countdown);
          this.randomclickImg();
        }
        else{
            t = t - 0.3;
            contentMain.style.backgroundImage = `linear-gradient(to right, ${frontColor} ${t}%, ${backColor} 0)`;
        }
    }, 20)
  }
  randomclickImg = () => {
    const { currentRow } = this.state;
    const currentRowSet = document.getElementsByClassName(`set${currentRow}`);

    const result = Math.floor(Math.random() * 2);
    try{
    const img = currentRowSet[0].children[result].children[0];
    img.click();
    } catch (error){
      console.log(error);
    }
  }

  render() {
    // console.log('===============> render');
    if (this.state.loaded) {

      const { elems } = this.state;    
      
      let elems_set = []
      for (var i=0; i<elems.length-1; i+=2) {
        elems_set.push([elems[i],elems[i+1]]);
      }

      const elemListBytwo = elems_set.map(
        (elem, index) => {
          let elem1 = elem[0];
          let elem2 = elem[1];
          const { round } = this.state;
          return(
            <div className={`set${index} set `} key={index}>
              <ContentDetail info={elem1} elems={elem1} round={round} onClick={this.handlePick} onImgClick={this.clickImg} />
              <ContentDetail info={elem2} elems={elem2} round={round} onClick={this.handlePick} onImgClick={this.clickImg} />
            </div>
          );
        }
      );
      const { boothId, round } = this.state;

      return(
        <Fragment>
          <div className={`content content-main content-main-round${round}`}>
            <a className="close" href="zepeto://WEBVIEW/CLOSE"><FontAwesomeIcon icon="times" /></a>
            <div className="content-card">
              
              <BounceInDiv><div className="title">Your Favorite <b>IDOL</b></div></BounceInDiv>
              <div className={`round round${round}`}>{this.state.round === 2 ? 'Final Round' : `Round of ${this.state.round}` }</div>
              <div className="vs">VS</div>
              
              <div className="contentDetail-wrapper">
                <BounceInDiv>
                  {elemListBytwo}
                </BounceInDiv>
              </div>
            
              <div className="contentComplete-wrapper">
                {this.state.displayResult ? (
                <div>
                  <Redirect from='/:boothId' to={{
                    pathname: `/${boothId}/result`,    // TODO: result componenet를 content 하위에 두도록 수정 / history 사용
                    state: {
                      boothId: {boothId},
                      resultId: this.state.elems
                    }
                  }} />
                </div>
                ) :(
                  <div></div>
                )}
              </div>
            </div>
          </div>
        <ContentStart onClick={this.startGame} />
      </Fragment>
      );
      
    }
    else {
      return(
        <Fragment>
        </Fragment>
      );
    }
  }
}
export default Content;